module.exports = __webpack_public_path__ + "media/images/vp/bg.gift.instructions-07343e92f35ca2dd70e2a0d6323ab502.png";